export enum SelectedOrgTypes {
  GETALL = '@selectedOrg/GETALL',
  GETALL_SUCCESS = '@selectedOrg/GETALL_SUCCESS',
  GETALL_FAILED = '@selectedOrg/GETALL_FAILED',
}
